import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

// Components
import { PredicatePart } from './PredicatePart';

// Enums
import { RULE_EDITOR_CHARS } from '../enums/ruleEditorChars';

const FlexBox = styled.div`
    display: flex;
    z-index: 1;
    align-items: center;
`;

const GroupLabel = styled.div`
    font-weight: bold;
    display: flex;
    align-items: center;
`;

export const PredicateGroupWrapper = ({ predicate, hasGroupFunction, children }) => {
    const content = children.length ? (
        children
    ) : (
        <PredicatePart isPlaceholder predicateType={predicate.predicateType} />
    );

    return (
        <FlexBox className="predicate-group-wrapper">
            {hasGroupFunction ? (
                <>
                    <GroupLabel>
                        {predicate.groupFunctionDTO.name}&nbsp;
                        {RULE_EDITOR_CHARS.FUNC_OPEN}&nbsp;
                        {content}
                    </GroupLabel>
                </>
            ) : (
                <GroupLabel>{content}</GroupLabel>
            )}
        </FlexBox>
    );
};

export default PredicateGroupWrapper;

PredicateGroupWrapper.propTypes = {
    predicate: PropTypes.object,
    hasGroupFunction: PropTypes.bool,
    children: PropTypes.node
};
